import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Tab, Table, Loader
} from 'semantic-ui-react';

// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import StudentPollPreview from './PollPreview/StudentPollPreview';


export default class CoursePollPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courseId: localStorage.getItem('courseId'),
            showPoll: false,
            professors: [],
            assistants: [],
            professor: [],
            assistant: [],
            staff: [],
            loader: true

        };
        this.fetchStaff = this.fetchStaff.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.fetchStaff();
    }
    checkInputValue() {
        if (!this.state.professor.length) {
            toast(<FormattedMessage id="common.requiredFields" />);
            // if (this.state.assistant.length === 0) { this.setState({ assistantErr: true }); } else { this.setState({ assistantErr: false }); }
            if (this.state.professor.length === 0) { this.setState({ professorErr: true }); } else { this.setState({ professorErr: false }); }
        } else {
            this.setState({ loader: true });
            let courseId = localStorage.getItem('courseId');
            let poll = JSON.parse(localStorage.getItem('poll'));
            let obj = { id: courseId };
            axios.post(`/questionnaire/connect-student/${poll.pollId}/`, { ...obj })
                .then(res => {
                    this.setState({ showPoll: true, loader: false });
                })
                .catch(err => {
                    this.setState({ loader: false });

                    if (err.response.data === 'ba.utic.isss.common.exceptions.IsssException: Student is already connected with this questionnaireLink!') {
                        this.setState({ showPoll: true, loader: false });
                    } else {
                        toast(<FormattedMessage id="poll.connectStudentToCourseError" />);
                        console.log('Failed to connect student to courseImplementationPoll.');
                    }
                });
        }
    }

    fetchStaff() {
        // axios.get(`/course/implementation/staff/${this.state.courseId}`)
        axios.get(`course/groups/staff-for-student/${this.state.courseId}/`)
            .then(res => {
                const staff = res.data.map(el => ({
                    value: el.id,
                    key: el._key,
                    text: el.employee.person.firstName + ' ' + el.employee.person.lastName,
                    position: el.courseRoleType.name
                }));
                const professors = [];
                const assistants = [];
                staff.map((e) => {
                    if (e.position === 'profesor') {
                        professors.push(e);
                    } else if (e.position === 'asistent') {
                        assistants.push(e);
                    }
                });
                localStorage.setItem('professors', JSON.stringify(professors));
                localStorage.setItem('assistants', JSON.stringify(assistants));
                this.setState({
                    staff, professors, assistants, loader: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch staff.');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        }, () => {
            if (name === 'professor')localStorage.setItem('selectedProfessors', JSON.stringify(value));

            if (name === 'assistant')localStorage.setItem('selectedAssistants', JSON.stringify(value));
        });
    }
    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        let poll = JSON.parse(localStorage.getItem('poll'));
        // eslint-disable-next-line prefer-destructuring
        let pollName = poll.pollName;
        let courseName = localStorage.getItem('courseName');

        return (

            <div>

                {/* preview */}
                {!this.state.showPoll && <Header as="h1"> <FormattedMessage id="poll.poll" /> </Header>}

                { this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader size="medium" active inline="centered" /></div> :


                    (!this.state.showPoll && this.state.professors.length !== 0) ? <Segment.Group raised clearing>
                        <Segment clearing >
                            <Header as="h3">
                                <FormattedMessage id="poll.selectStaffForCourse" values={{ courseName }} />
                                <p style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                    <FormattedMessage id="poll.assistantGradingOptionalNotice" />
                                </p>
                            </Header>
                        </Segment>
                        <Segment clearing>
                            <Form>
                                <Form.Group >
                                    <Form.Field
                                        width={6}
                                        required
                                        error={this.state.professorErr}

                                    >
                                        <label>
                                            {/* {<FormattedMessage id="common.notificationType" />} */}
                                            <FormattedMessage id="poll.professorsLabel" />
                                        </label>
                                        <Form.Dropdown
                                            clearable
                                            multiple
                                            placeholder={<FormattedMessage id="poll.placeholderProfessors" />}
                                            value={this.state.professor}
                                            onChange={this.handleInputChange}
                                            name="professor"
                                            options={this.state.professors}
                                            search
                                            fluid
                                            selection
                                            required
                                            error={this.state.professorErr}
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        width={6}
                                    // required
                                    // error={this.state.assistantErr}
                                    >
                                        <label>
                                            {/* {<FormattedMessage id="common.notificationType" />} */}
                                            <FormattedMessage id="poll.assistantsLabel" />
                                        </label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder={<FormattedMessage id="poll.placeholderAssistants" />}
                                            value={this.state.assistant}
                                            onChange={this.handleInputChange}
                                            name="assistant"
                                            options={this.state.assistants}
                                            search
                                            fluid
                                            multiple
                                            selection
                                        // error={this.state.assistantErr}
                                        />
                                    </Form.Field>
                                    <Form.Field width={2} >
                                        <label>

                                            <br />
                                        </label>
                                        <Button color="blue" fluid onClick={() => { this.checkInputValue(); }} ><FormattedMessage id="poll.continueButton" /></Button>
                                    </Form.Field>
                                    <Form.Field width={2}>
                                        <label>

                                            <br />
                                        </label>
                                        <Link to={{
                                            pathname: '/anketa/predmeti'

                                        }}
                                        >
                                            <Button
                                                color="blue"
                                                fluid
                                                basic="true"
                                                onClick={() => {
                                                    localStorage.removeItem('courseId');
                                                    localStorage.removeItem('courseName');
                                                    localStorage.removeItem('professors');
                                                    localStorage.removeItem('assistants');
                                                }}
                                            ><FormattedMessage id="poll.cancel" /></Button>
                                        </Link>
                                    </Form.Field >

                                </Form.Group>
                            </Form>


                        </Segment>
                        {/* <Segment clearing> */}

                        {/*    <Button floated="left" color="blue" basic="true" onClick={() => this.setState({ open: false })}>Odustani</Button> */}


                        {/*    <Button floated="right" color="blue" >Nastavi</Button> */}


                        {/* </Segment> */}
                        <ToastContainer hideProgressBar />
                    </Segment.Group> : !this.state.loader && !this.state.showPoll && <FormattedMessage id="poll.noProfessorsAssigned" />}

                {this.state.showPoll &&
                <div>

                    <StudentPollPreview showSubmitButton />


                </div>
                }


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/StudentPoll/CoursePollPreview.js